"use client";

import { AuthContext, useRuntimeConfig } from "@finbackoffice/site-core";
import { usePathnameWithLocal } from "hooks";
import { BetSlipItemsContext, UIStateContext } from "contexts";
import { useDevice } from "hooks";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import { FC, useContext, useMemo } from "react";
import { DESKTOP_SCREEN_WIDTH, RouteNames } from "utils/constants";

const CookiesConsent = dynamic(() => import("components/cookie-consent/CookiesConsent"), {
    ssr: false,
});

const FloatingLogin = dynamic(() => import("components/floating-login/FloatingLogin"), {
    ssr: false,
});

const FloatingBetSlipPanel = dynamic(
    () => import("components/sport/betslip/floating-betslip-panel/FloatingBetSlipPanel"),
    {
        ssr: false,
    },
);

const PositionFixedComponents: FC = () => {
    const pathname = usePathname();
    const { pathnameValues } = usePathnameWithLocal();
    const { isMobileDevice, screenWidth } = useDevice();

    const { isNotFoundPage } = useContext(UIStateContext);
    const { isUserLoggedIn } = useContext(AuthContext);
    const { betItems } = useContext(BetSlipItemsContext);
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");

    const showBetSlipPanel = useMemo(() => {
        const isSport =
            pathname.includes(`${RouteNames.SPORT}/${RouteNames.LIVE}`) ||
            pathname.includes(`${RouteNames.SPORT}/${RouteNames.PREMATCH}`) ||
            pathname.includes(`${RouteNames.SPORT}/${RouteNames.UPCOMING}`) ||
            pathname.includes(`${RouteNames.SPORT}/${RouteNames.RESULTS}`) ||
            pathname.includes(`${RouteNames.SPORT}/${RouteNames.CALENDAR}`) ||
            pathname.includes(`${RouteNames.SPORT}/${RouteNames.MULTI_VIEW}`);
        const isHome = pathnameValues.length === 0;

        return (
            !isMobileDevice &&
            screenWidth < DESKTOP_SCREEN_WIDTH &&
            (isSport || isHome) &&
            !isNotFoundPage &&
            betItems.length > 0
        );
    }, [
        pathname,
        pathnameValues.length,
        isMobileDevice,
        screenWidth,
        isNotFoundPage,
        betItems.length,
    ]);

    return (
        <>
            {COMMON_SITE_CONFIGS.cookiesConsentPopup && <CookiesConsent />}
            {COMMON_SITE_CONFIGS.login.floatingLogin && !isUserLoggedIn && (
                <FloatingLogin bottomPosition={showBetSlipPanel ? 82 : undefined} />
            )}
            <FloatingBetSlipPanel visible={showBetSlipPanel} />
        </>
    );
};

export default PositionFixedComponents;
